/**
 * Get more
 */

import '../../js/vendor/polyfills/polyfill-array-from.js';
import '../../js/vendor/polyfills/polyfill-classlist.js';
import '../../js/vendor/polyfills/polyfill-window-url.js';
import '../../js/vendor/polyfills/polyfill-remove.js';
import '../../js/vendor/polyfills/polyfill-nodelist-foreach.js';
// Import extend function.
import Component from '../../js/core/component.js';
import getFragment from '../../js/utilities/get-fragment/u-get-fragment.js';

class GetMore extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			getMore: null,
			getMoreButtonContainer: null,
			listContainer: null,
			pagination: null,
			currentIndex: 1,
			totalPages: 1,
			button: null,
			dataUrl: null,
			text: {
				loadMore: 'Läs in fler'
			}
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.debug = this.settings.debug;
		this.getMore = this.settings.getMore;
		this.totalPages = this.getMore.getAttribute('data-total-pages');
		this.currentIndex = this.getMore.getAttribute('data-current-index');
		this.listContainer = this.getMore.querySelector('ul');
		this.pagination = this.getMore.querySelector('.c-pagination');
		this.dataUrl = window.location.href;
		this.init();
	}

	_createGetMoreButton() {
		if (!this.pagination && !this.dataUrl) {
			return;
		}
		this.pagination.style.display = 'none';

		this.getMoreButtonContainer = document.createElement('div');
		this.getMoreButtonContainer.classList.add('c-get-more'); 

		this.button = document.createElement('button');
		this.button.setAttribute('type', 'button');
		this.button.classList.add('c-button');
		this.button.innerHTML = 'Läs in fler';
		
		this.getMoreButtonContainer.appendChild(this.button);
		this.getMore.appendChild(this.getMoreButtonContainer);
		this.button.addEventListener('click', this._loadMoreItems.bind(this));
	}

	_loadMoreItems() {
		if (!this.listContainer && !this.button && !this.dataUrl) {
			return;
		}

		let nextPage = +this.getMore.getAttribute('data-current-index') + 1;

		if (Number(this.getMore.getAttribute('data-current-index')) >= Number(this.totalPages)) {
			this._destroy();
			return;
		}

		let url = this.dataUrl + '?s=' + nextPage + '#get-more-container';

		if (this.debug === true) {
			url = '/pages/component.html?path=~\\components\\get-more\\_xhr\\result.html#get-more-container';
		}

		getFragment({
			url: url,
			onSuccess: (response) => {
				this.getMore.setAttribute('data-current-index', +nextPage);

				let listElements = response[0].querySelectorAll('li');

				listElements.forEach((item) => {
					this.listContainer.appendChild(item);
				});
			}
		}, 'get-more-container').catch(console.error);
	}

	_destroy() {
		this.getMoreButtonContainer.remove();
	}

	/* =============================================================================
	 * Public methods
	============================================================================= */

	init () {
		if (!this.getMore) {
			return;
		}

		this._createGetMoreButton();
	}
}
document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('[data-js-get-more]').forEach((element) => {
		element.getMore = new GetMore({
			debug: false,
			getMore: element
		});
	});
});

export default GetMore;


// WEBPACK FOOTER //
// ./components/get-more/c-get-more.js